import {
  AnalysisMainViewItemType,
  MainViewComponentProps,
  StepInitializationAnalysisMainViewItem,
} from 'analysis-tool/ui/main-view/MainViewTypes';
import {RESTAnalyticsParameterConfig, RESTWarehouseParameter} from 'insights/parameters/RESTParameterTypes';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {Override} from 'util/Types';

export interface InputTableColumnReference {
  dataFrameName: string;
  columnSystemName: string;
}

export enum DataFrameCreationMethod {
  DATA_CATALOG = 'DATA_CATALOG',
  INSIGHTS_BLOCK = 'INSIGHTS_BLOCK',
  PLATE_SCHEMA = 'PLATE_SCHEMA',
  REGISTRY_SCHEMA = 'REGISTRY_SCHEMA',
  UPLOAD_CSV = 'UPLOAD_CSV',
  COMBINE_DATA_FRAMES = 'COMBINE_DATA_FRAMES',
  LOOK_UP = 'LOOK_UP',
}

export interface DataFrameCreationMethodOptions {
  icon: BenchlingIconName;
  initializationViewItem: StepInitializationAnalysisMainViewItem;
  text: string;
  /** Used for analytics event tracking */
  analyticsEventName: string;
  isEnabled: () => boolean;
  canReplace: boolean;
  dataTestAttrs?: DataTestAttrs;
}

export interface DataFrameNameState {
  name: string;
  hasUserEdits: boolean;
}

export type SharedCreateDataFrameViewProps<
  TFinalizeDataFrameRequest extends Array<unknown>, // Args of functions are types as a list
  TFinalizeDataFrameResponse,
  TAnalysisMainViewItemType extends AnalysisMainViewItemType = AnalysisMainViewItemType,
> = {
  onCancel: () => void;
  finalizeDataFrame: (...requestData: TFinalizeDataFrameRequest) => Promise<TFinalizeDataFrameResponse>;
  onDataFrameFinalized: (responseData: TFinalizeDataFrameResponse) => void;
} & MainViewComponentProps<TAnalysisMainViewItemType>;

export type RESTIdentifiedWarehouseParameter = Override<
  RESTWarehouseParameter,
  {config: Pick<RESTAnalyticsParameterConfig, 'isMulti' | 'systemName' | 'type' | 'id'>}
>;
